export default __webpack_public_path__ + "static/media/likes.8ba42bb5.svg";